import BlogHero from "../components/blog/BlogHero";
import BlogListing from "../components/blog/BlogListing";
import useSEO from "../hooks/useSEO";

export default function BlogPage() {
  const seo = useSEO({});

  return (
    <>
      {seo}
      <BlogHero />
      <BlogListing />
    </>
  );
}
